import React, { FC } from "react";

import { EntityFormActions } from "../../../../common/entity-form";

type CompensationProcedureFormActionProps = {
    mode: string;
    onDeleteClick: () => void;
    onSaveClick: () => void;
    onEditClick: () => void;
    onShowLogsClick: () => void;
};

const CompensationProcedureFormAction: FC<CompensationProcedureFormActionProps> = ({ mode, onDeleteClick, onSaveClick, onEditClick, onShowLogsClick }) => {
    return <EntityFormActions mode={mode} onDeleteClick={onDeleteClick} onSaveClick={onSaveClick} onEditClick={onEditClick} onShowLogsClick={onShowLogsClick} />;
};

export default CompensationProcedureFormAction;
